"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = void 0;
const default_session_1 = require("../../../../session/default-session");
const metadata_provider_1 = require("../metadata-provider");
function Definition(params) {
    return {
        getData(session = (0, default_session_1.getDefault)()) {
            const metadataProvider = new metadata_provider_1.MetadataProvider(session);
            return metadataProvider.getInstrument(params);
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2hpc3RvcmljYWwtcHJpY2luZy9tZXRhZGF0YS9pbnN0cnVtZW50L2RlZmluaXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EseUVBQWlFO0FBQ2pFLDREQUF3RDtBQUV4RCxTQUFnQixVQUFVLENBQUMsTUFBb0Q7SUFDM0UsT0FBTztRQUNILE9BQU8sQ0FBQyxVQUFtQixJQUFBLDRCQUFVLEdBQUU7WUFDbkMsTUFBTSxnQkFBZ0IsR0FBRyxJQUFJLG9DQUFnQixDQUFDLE9BQU8sQ0FBQyxDQUFDO1lBRXZELE9BQU8sZ0JBQWdCLENBQUMsYUFBYSxDQUFDLE1BQU0sQ0FBQyxDQUFDO1FBQ2xELENBQUM7S0FDSixDQUFDO0FBQ04sQ0FBQztBQVJELGdDQVFDIn0=